/**
 * SEEN luxury header — minimal enhancements.
 * Shop dropdown keyboard support + scroll shadow class.
 */
(function () {
  const header = document.querySelector('#header-component');
  if (!header) return;

  /* Subtle shadow when header becomes solid on scroll */
  const onScrollState = () => {
    const solid = header.dataset.stickyState === 'active';
    header.classList.toggle('seen-header--scrolled', solid);
  };

  new MutationObserver(onScrollState).observe(header, {
    attributes: true,
    attributeFilter: ['data-sticky-state'],
  });
  onScrollState();

  /* Shop dropdown — keyboard accessible */
  const dropdownItem = document.querySelector('.seen-luxury-nav__item--dropdown');
  if (!dropdownItem) return;

  const trigger = dropdownItem.querySelector('.seen-luxury-nav__trigger');
  const panel = dropdownItem.querySelector('.seen-luxury-nav__dropdown');
  if (!trigger || !panel) return;

  let closeTimer;

  const open = () => {
    clearTimeout(closeTimer);
    trigger.setAttribute('aria-expanded', 'true');
  };

  const close = () => {
    trigger.setAttribute('aria-expanded', 'false');
  };

  const scheduleClose = () => {
    closeTimer = setTimeout(close, 120);
  };

  dropdownItem.addEventListener('mouseenter', open);
  dropdownItem.addEventListener('mouseleave', scheduleClose);
  dropdownItem.addEventListener('focusin', open);
  dropdownItem.addEventListener('focusout', (e) => {
    if (!dropdownItem.contains(e.relatedTarget)) scheduleClose();
  });

  trigger.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      close();
      trigger.focus();
    }
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      trigger.getAttribute('aria-expanded') === 'true' ? close() : open();
    }
  });
})();
